const logoPath = getLogoPath();

interface SupportRentLogoProps {
  size?: number;
}
export const SupportRentLogo = ({ size }: SupportRentLogoProps) => {
  return <img src={logoPath} height={size || 64} width={size || 64} />;
};

function getLogoPath() {
  switch (window.location.hostname) {
    case "localhost":
      return "/images/logo-dev.svg";
    case "support.qa-smartrent.com":
      return "/images/logo-qa.svg";
    default:
      return "/images/logo.svg";
  }
}
